/**
 * Статус единицы оборудования — зеркало App\Enums\InventoryItemStatusType.
 */
export default class InventoryItemStatusType {
    static IN_STOCK = 0;
    static RESERVED = 1;
    static IN_USE = 2;
    static IN_REPAIR = 3;
    static BROKEN = 4;
    static DECOMMISSIONED = 5;
}
